import type { MergeExclusive } from "type-fest"
import type { FileDownloadOptions } from "../../../../../hooks"
import {
  type ExportModalProps,
  MultipleExportsButton,
  SingleExportButton,
} from "../../../ExportButtons"

export type ExportButtonProps = MergeExclusive<
  FileDownloadOptions,
  Omit<ExportModalProps, "open" | "onClose">
>

/** @deprecated - This component is only for Table, use directly SingleExportButton or MultipleExportsButton instead */
export const ExportButton = (props: ExportButtonProps) => {
  if (props.endpoint) {
    return <SingleExportButton export={props} />
  }

  return <MultipleExportsButton {...(props as ExportModalProps)} />
}
